import { Directive } from '@angular/core';
import { AfterContentChecked } from '@angular/core';
import { Input } from '@angular/core';
import { Renderer, ElementRef } from '@angular/core';
import { FeatureTogglerService } from '../services/feature-toggler.service';

@Directive({
  selector: '[appFeatureToggler]'
})
export class FeatureTogglerDirective  implements  AfterContentChecked {

  // tslint:disable-next-line:no-input-rename
  @Input() appFeatureToggler: string;
  constructor(
    public el: ElementRef,
    public renderer: Renderer,
    public toggleService: FeatureTogglerService) { }

  ngAfterContentChecked() {
    if (! this.toggleService.hasFeature(this.appFeatureToggler)) {
        this.renderer.setElementProperty(this.el.nativeElement, 'hidden', 'true');
    }
}

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/directives/feature-toggler.directive.ts